import { TypographyVariantsOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyVariantsOptions = {
  fontFamily: '"Poppins", sans-serif',
  fontWeightBold: 600,
  h1: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 600,
    fontSize: '2.4rem',
    lineHeight: 1.4,
  },
  h2: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 600,
    fontSize: '2.3rem',
    lineHeight: 1.4,
  },
  h3: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 600,
    fontSize: '2.1rem',
    lineHeight: 1.4,
  },
  h4: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 600,
    fontSize: '1.9rem',
    lineHeight: 1.4,
  },
  h5: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 600,
    fontSize: '1.7rem',
    lineHeight: 1.5,
  },
  h6: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  subtitle1: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
    fontSize: '1.7rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  body1: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 400,
    fontSize: '1.7rem',
    lineHeight: 1.5,
  },
  body2: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  button: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  buttonSmall: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
    fontSize: '1.3rem',
    lineHeight: 1.5,
  },
  buttonLarge: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
    fontSize: '1.5rem',
    lineHeight: 1.4,
  },
  overline: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: 1.5,
    textTransform: 'initial',
  },
  caption: {
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: 1.5,
  },
};
